"use client";

import React from "react";
import { Clock, ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { PostsProvider, usePosts } from "@/integrations/wordpress/WordPressPostsProvider";
import { WP_Query } from "@/integrations/wordpress/wp_query";
function BlogGridConsumer() {
  const {
    posts,
    loading,
    error
  } = usePosts();
  if (loading) {
    return <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-12">
        {[...Array(4)].map((_, i) => <div key={i} data-index={i} className="flex flex-col rounded-md overflow-hidden bg-muted animate-pulse h-[400px]">
            <div className="w-full aspect-video bg-muted/50"></div>
            <div className="p-6 flex flex-col flex-grow gap-4">
              <div className="h-4 w-1/3 bg-muted/50 rounded-md"></div>
              <div className="h-6 w-3/4 bg-muted/50 rounded-md"></div>
              <div className="h-4 w-full bg-muted/50 rounded-md"></div>
              <div className="h-4 w-2/3 bg-muted/50 rounded-md"></div>
            </div>
          </div>)}
      </div>;
  }
  if (error) {
    return <div className="text-center py-12 text-muted-foreground">
        <p>Unable to load resources at this time.</p>
      </div>;
  }
  if (!posts || posts.length === 0) {
    return <div className="text-center py-12 text-muted-foreground">
        <p>No articles found.</p>
      </div>;
  }
  return <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-12">
      {posts.map((post, i) => <article key={post.id} data-index={i} className="flex flex-col rounded-md overflow-hidden bg-card shadow-md transition-shadow hover:shadow-lg border border-border">
          <Link to={post.link || "#"} className="block aspect-video overflow-hidden">
            <img src={post.featuredImage || "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1615668/img/crawl_space_maintenance.png"} alt={post.title} className="w-full h-full object-cover transition-transform hover:scale-105 duration-500" />
          </Link>
          <div className="p-6 flex flex-col flex-grow">
            <div className="flex items-center gap-3 mb-4 text-xs text-muted-foreground">
              {post.categories && post.categories.length > 0 && <span className="font-default font-medium text-primary bg-primary/10 px-2.5 py-0.5 rounded-md">
                  {post.categories[0].name}
                </span>}
              <span className="font-default">{post.date || "Recent Post"}</span>
              <span className="flex items-center gap-1 font-default">
                <Clock className="w-3.5 h-3.5" /> 4 min read
              </span>
            </div>
            
            <Link to={post.link || "#"} className="group">
              <h3 className="text-xl md:text-2xl font-bold text-foreground font-default mb-3 group-hover:text-primary transition-colors line-clamp-2">
                {post.title}
              </h3>
            </Link>
            
            <div className="text-muted-foreground font-default text-sm line-clamp-2 mb-6 flex-grow" dangerouslySetInnerHTML={{
          __html: post.excerpt || ""
        }} />
            
            <div className="flex flex-col gap-4 mt-auto">
              <Link to={post.link || "#"} className="text-primary font-bold text-sm flex items-center gap-1.5 hover:underline w-fit font-default">
                Read Full Article <ArrowRight className="w-4 h-4" />
              </Link>
              <Link to="/ContactPage" className="bg-primary text-primary-foreground px-4 py-2 rounded-md text-sm font-bold text-center hover:bg-secondary transition-colors font-default">
                Get Connected to a Specialist
              </Link>
            </div>
          </div>
        </article>)}
    </div>;
}
export default function Blogresources() {
  const wp_query_params = {
    post_type: "post",
    per_page: 4
  };
  const wp_query = new WP_Query(wp_query_params);
  return <section data-section-id="258820" id="blogresources" className="py-16 bg-background text-foreground">
      <div className="text-center max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <span className="text-primary font-bold tracking-wider uppercase text-sm font-default">
          Expert Insights
        </span>
        <h2 className="mt-3 text-3xl md:text-4xl font-bold text-foreground font-default">
          Crawl Space Resources & Tips
        </h2>
        <p className="mt-4 text-muted-foreground font-default">
          Stay informed with the latest advice on moisture control, mold prevention, and maintaining a healthy home environment in Des Moines.
        </p>
      </div>
      
      <PostsProvider wp_query={{
      post_type: "post",
      per_page: 4
    }}>
        <BlogGridConsumer />
      </PostsProvider>

      <div className="mt-12 text-center">
        <Link to="/ServicesPage" className="inline-flex items-center justify-center px-6 py-3 border border-primary text-primary font-bold rounded-md hover:bg-accent transition-colors font-default">
          View All Articles
        </Link>
      </div>
    </section>;
}